import React from 'react';
import styles from './external-url-item-header.scss';

export const ExternalUrlItemHeader: React.FC<React.PropsWithChildren> = ({ children }) =>
  <div className={styles.headerWrapper}>
    {children}
  </div>;
